module.exports = __webpack_public_path__ + "img/70.e2404720.jpg";